import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
    catchError,
    filter,
    map,
    switchMap,
    tap,
    withLatestFrom
} from 'rxjs/operators';
import * as R from 'ramda';
import * as RA from 'ramda-adjunct';

import { AuthActions } from '@emm/auth/store/auth.actions';
import { AuthApiService } from '../auth-api.service';
import { UserService } from '@emm/core/services/user.service';
import {RouterStoreService} from '@emm/core/store/router-store.service';
import {RouterActions} from '@emm/core/store/router.actions';

@Injectable({
    providedIn: 'root',
})
export class AuthEffects {

    authenticateUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.authenticateUser),
            switchMap((_) =>
                this.userService.getUser().pipe(
                    map((user) =>
                        RA.isNotNilOrEmpty(user)
                            ? AuthActions.authenticateUserSuccess({ user })
                            : AuthActions.authenticateUserFailure({ error: 'authentication error' })
                    ),
                    catchError(({ error }) => of(AuthActions.authenticateUserFailure({ error })))
                )
            )
        )
    );

    authenticateUserSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.authenticateUserSuccess),
            withLatestFrom(this.routerStore.selectUrl()),
            map(R.last),
            map((currentUrl) => {
                const defaultUrl = currentUrl === '' || currentUrl === '/login' ? 'menu' : currentUrl;
                return defaultUrl;
            }),
            filter(RA.isNotNilOrEmpty),
            switchMap((redirectUrl) => of(RouterActions.go({ path: [redirectUrl] })))
        )
    );

    signOut$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.signOut),
            tap(
                (_) => this.userService.signOut()),
                switchMap(() => of(RouterActions.go({ path: ['login'] }))
            )
        )
    );

    constructor(
        private actions$: Actions,
        private api: AuthApiService,
        private routerStore: RouterStoreService,
        private userService: UserService
    ) {}

}
